import { useLayoutEffect, useState } from "react";
import GuestCheckoutFormModal, {
  type GuestCheckoutFormData,
} from "~/Cart/pages/CartPage/B2CCart/components/GuestCheckoutDialog/components/GuestCheckoutFormModal";
import { GuestCheckoutLoginModal } from "~/Cart/pages/CartPage/B2CCart/components/GuestCheckoutDialog/components/GuestCheckoutLoginModal";
import ResetPasswordPopup from "~/Login/components/ResetPasswordPopup";
import LoginPopup from "~/Login/components/LoginPopup";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { CART_STEP_3 } from "~/utils/url/staticUrls";

export type GuestCheckoutModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (formData: GuestCheckoutFormData) => void;
};

const Page = {
  Main: "main",
  Form: "form",
  ResetPassword: "resetPassword",
  Login: "login",
} as const;

export const GuestCheckoutModal = ({ open, onClose, onSubmit }: GuestCheckoutModalProps) => {
  const [page, setPage] = useState<(typeof Page)[keyof typeof Page]>(Page.Main);
  const [email, setEmail] = useState<string>("");

  useLayoutEffect(() => {
    if (open) {
      setPage(Page.Main);
    }
  }, [open]);

  return (
    <>
      <GuestCheckoutLoginModal
        open={open && page === Page.Main}
        onClose={onClose}
        onContinueAsGuest={() => setPage(Page.Form)}
        onResetPassword={(email) => {
          setEmail(email);
          setPage(Page.ResetPassword);
        }}
      />
      {open && page === Page.ResetPassword && <ResetPasswordPopup close={onClose} initialEmail={email} />}
      <GuestCheckoutFormModal
        open={open && page === Page.Form}
        onClose={onClose}
        onSubmit={onSubmit}
        onLoginClick={(email: string) => {
          setEmail(email);
          setPage(Page.Login);
        }}
      />
      {open && page === Page.Login && (
        <LoginPopup
          initialEmail={email}
          onResetClick={() => setPage(Page.ResetPassword)}
          close={onClose}
          alternativeLoginAction={() => redirectToUrl(CART_STEP_3)}
        />
      )}
    </>
  );
};
